// Pagination Component
const Pagination = ({ total, perPage, currentPage, onPageChange, onPerPageChange }) => {
  const totalPages = Math.ceil(total / perPage);

  // Determine page numbers to display dynamically
  const pageNumbers = [];
  const visiblePages = 3; // Number of pages to show in the window
  const halfVisible = Math.floor(visiblePages / 2);

  if (totalPages <= visiblePages + 1) {
    // Show all pages if total pages are few
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
  } else {
    let startPage = Math.max(1, currentPage - halfVisible);
    let endPage = Math.min(totalPages, startPage + visiblePages - 1);

    if (endPage - startPage < visiblePages - 1) {
      startPage = Math.max(1, endPage - visiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    if (startPage > 1) {
      pageNumbers.unshift('...'); // Add ellipsis at the start if not at beginning
      pageNumbers.unshift(1); // Always include first page
    }
    if (endPage < totalPages) {
      pageNumbers.push('...'); // Add ellipsis before last page if not at end
      pageNumbers.push(totalPages); // Always include last page
    }
  }

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between mt-6 gap-4">
      <div className="flex items-center space-x-2">
        <span className="text-[clamp(12px,2vw,14px)] text-gray-700">Records per page:</span>
        <select
          value={perPage}
          onChange={(e) => onPerPageChange(parseInt(e.target.value))}
          className="border rounded-md px-2 py-1 text-[clamp(12px,2vw,14px)] focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {[10, 20, 50, 100, 200, 300, 500].map((num) => (
            <option key={num} value={num}>{num}</option>
          ))}
        </select>
      </div>
      <div className="flex flex-wrap gap-2 justify-center sm:justify-end">
        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          className={`px-3 py-2 rounded-md text-[clamp(12px,2vw,14px)] ${currentPage === 1 ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
        >
          First
        </button>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-3 py-2 rounded-md text-[clamp(12px,2vw,14px)] ${currentPage === 1 ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
        >
          Prev
        </button>
        {pageNumbers.map((num, index) => (
          <button
            key={index}
            onClick={() => num !== '...' && onPageChange(num)}
            className={`px-3 py-2 rounded-md text-[clamp(12px,2vw,14px)] ${num === '...' ? 'bg-gray-200 text-gray-700 cursor-default' : currentPage === num ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
            disabled={num === '...'}
          >
            {num}
          </button>
        ))}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`px-3 py-2 rounded-md text-[clamp(12px,2vw,14px)] ${currentPage === totalPages ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
        >
          Next
        </button>
        <button
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          className={`px-3 py-2 rounded-md text-[clamp(12px,2vw,14px)] ${currentPage === totalPages ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
        >
          Last
        </button>
      </div>
    </div>
  );
};
  
  export default Pagination;